import logo1 from "../assets/img/logo1.svg";
import logo2 from "../assets/img/logo2.svg";

export const DECIMAL_NUMBER_REGX = /^(\d*\.{0,1}\d{0,2}$)/;
export const US_CURRENCY_FORMAT = "en-US";
export const INDIA_CURRENCY_FORMAT = "en-IN";
export const REMITTANCE_HOME_PATH = "/remittance";
export const REMITTANCE_NB_HOME_PATH = "/remittance/dashboard";
export const DEFAULT_REMITTANCE_AMOUNT = 1000;

export const STEPS = [
  {
    label: "Signup",
    description: `Use your phone number to signup`,
    updatedLabel: "Signup Completed",
  },
  {
    label: "Complete Verification",
    description: "Enter your basic details and complete the KYC.",
    updatedLabel: "Verification Completed",
  },
  {
    label: "Send Money To India",
    description: `Add recipient and send money to India at best Fx rates`,
    updatedLabel: "Money Sent successfully",
  },
];

export const FEATURE_NOT_AVAILABLE_MESSAGE =
  "We are sorry! This feature is not available on the web. Kindly download the App.";

export const EMAIL_REGX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const US_PHONE_FORMAT = /^(1|)?(\d{3})(\d{3})(\d{4})$/;

export const CRICBUZZ_SLIDER_ITEMS = [
  {
    isPromoCard: true,
  },
  {
    leftSection: {
      background: "#466BFF",
      text1: "Cash back on desi",
      text2: "snacks from your fave",
      text3: "restaurants on Doordash",
      logo: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/logo1.svg",
    },
    rightSection: {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/Group+10123136.png",
    },
  },

  {
    leftSection: {
      background: "#017995",
      text1: "Exclusibe rewards on ",
      text2: " Gully Cricket to play",
      text3: " fantasy cricket",
      logo: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/logo2.svg",
    },
    rightSection: {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/Group+10123136+(1).png",
    },
  },
  {
    leftSection: {
      background: " #FF6400",
      text1: "Host a watch party",
      text2: "with friends and get",
      text3: "cashback on groceries",
      logo: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/image+130.png",
    },
    rightSection: {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/Groupimagefood.png",
    },
  },
  {
    leftSection: {
      background: "#1C1C1C",
      text1: "Buy exclusive team ",
      text2: "jersey’s from top",
      text3: "retailers",
    },
    rightSection: {
      url: "https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/cricbuzz/Groupimage.png",
    },
  },
];

export const ABOUND_STATS = [
  {
    value: "$7.7M",
    label: "Cash Back earned by Abound Users",
  },
  {
    value: "$150M+",
    label: "Sent to India via Abound",
  },
  {
    value: "800k+",
    label: "NRIs have joined the Abound family",
  },
];

export const EVENT_SOURCE_CHANNEL_MAP = {
  TOI: "toi_mobile",
  TOI_WEB: "toi_web",
};
